// Order-queue status text is written by the order-handler for operators, and some of
// it names internal production steps (RPE ripping, JDML, the Modal renderer). Brands
// must never see that vocabulary, so every customer-facing render goes through here.

const INTERNAL_TERMS = /\b(rpes?|jdml|rip|ripping|ripped|modal|hotfolder|file-listener)\b/i;

export const PRINT_PREP_MESSAGE = 'Preparing your design files to printer specifications.';

// #region customerQueueMessage
/**
 * Returns the queue message safe to show a brand. A message that mentions an
 * internal production step is replaced with neutral print-preparation copy.
 * Super-access users pass `showRaw` to see the operator text unchanged.
 */
export const customerQueueMessage = (message: string | null | undefined, showRaw = false): string => {
    if (!message) return '';
    if (showRaw || !INTERNAL_TERMS.test(message)) return message;
    return PRINT_PREP_MESSAGE;
};

// #region customerQueueStatus
/** Display label for a raw `process_status`; `ripping` is shown as print preparation. */
export const customerQueueStatus = (status: string | null | undefined, showRaw = false): string => {
    if (!status) return '';
    if (showRaw) return status;
    return status.toLowerCase() === 'ripping' ? 'preparing print files' : status;
};
